import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import { AppPermissions } from 'kiosko-common';
import theme from '../styles/theme';
import CompanySelectorComponent from 'ui/components/companySelector/company-selector';
import { Layout } from 'ui';

const Home: NextPage = () => {
  const user = useUser();
  return (
    <Layout
      pageTitle="Kiosko"
      userName={user?.name}
      userLogout={user?.actions?.logout}
      customHeaderStyle={{
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
      }}
    >
      <CompanySelectorComponent
        user={user}
        options={{
          gascaribe: {
            path: '/gascaribe',
            role: AppPermissions.GasesCaribe,
          },
          gasguajira: {
            path: '/gasguajira',
            role: AppPermissions.GasesGuajira,
          },
          efigas: {
            path: '/efigas',
            role: AppPermissions.Efigas,
          },
        }}
      />
    </Layout>
  );
};

export default Home;
